// ZLAYT-1573: on a phone the table is too wide to show Client, Type, Status
// and Action together, so the date and user columns are left out there. The
// row still opens the document (ZLAYT-1579), which shows them.
const PHONE_HIDDEN_COLUMNS = ['updated_at', 'created_at', 'creator_name'];

export const documentColumnVisibility = (
  isPhone: boolean
): Record<string, boolean> =>
  Object.fromEntries(PHONE_HIDDEN_COLUMNS.map((id) => [id, !isPhone]));
